import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AppState } from "../../../../../../stateManager/store";
import { getValue, getComponents } from "../../helpers";
import { Checkbox } from "./helpers/constants";
import { onChange } from "./helpers/on-change"
import { Tooltip } from "../../helpers/Toottip";  

const DEFAULT_VISIBILITY: string = "properties.styles.$deviceType.visible";

type Props = {
  isCheckedIn: boolean;
  defaultValue?: boolean;
}

export const Visible = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType } = useSelector((state: AppState) => state.formJson)
  const { isCheckedIn, defaultValue } = props;
  const [oldValue, setOldValue] = useState(Boolean);
  const [value, setValue] = useState(defaultValue);
  const component = components[selectedElementId];

  useEffect(() => {
    if (component) {
      const previousValue = getValue(component, DEFAULT_VISIBILITY.split("."), deviceType);
      setValue(previousValue)
      setOldValue(previousValue)
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_VISIBILITY.split("."), deviceType)]);

  return (
    <Tooltip content="Hide this widget to declutter your screen on this device. You can always show it again later.">
      <Checkbox
        type={component?.type}
        disabled={!isCheckedIn}
        key={"visible"}
        id={"visible"}
        labelStyle={{ borderBottom: "1px dotted #B4B4B4" }}
        value={value ? value : false}
        label={"Widget Visibility"}
        onChange={(_, value: boolean) => {
          setValue(value);
          onChange({
            path: DEFAULT_VISIBILITY,
            value,
            oldValue,
            setOldValue,
            selectedElementId
          })
        }}
      />
    </Tooltip>
  )
};